<div mat-dialog-title>
  <span class="pill">{{ data.status }}</span>
  <p class="summary-subtext">
    {{data.comment}}
  </p>
</div>

<mat-progress-bar mode="query"></mat-progress-bar>
<mat-dialog-content>
  <div class="summary-row">
    <div>
      <div class="summary-label">Participant</div>
      <div class="summary-value">{{ data.participant }}</div>      
    </div>   
  </div>
  <div class="divider"></div>  
  <div class="summary-row">
    <div>
      <div class="summary-label">Selected claims</div>
      <div class="summary-value">{{data.totalCount }}</div>
    </div>
    <div style="text-align: right;">
      <div class="summary-label">Total</div>
      <div class="summary-value">{{data.totalAmount | currency}}</div>
    </div>
  </div>

  <div class="divider"></div>
</mat-dialog-content>

<style>
  .summary-section-title {
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
    color: #6B778C;
    margin-bottom: 6px;
  }

  .summary-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;
  }

  .summary-label {
    font-weight: 500;
    color: #42526E;
  }

  .summary-value {
    font-weight: 600;
    color: #172B4D;
  }

  .summary-subtext {
    font-size: 11px;
    color: #6B778C;
    margin-top: 2px;
  }

  .divider {
    border-top: 1px solid #DFE1E6;
    margin: 12px 0;
  }

  .pill {
    display: inline-block;
    padding: 2px 6px;
    font-size: 11px;
    border-radius: 10px;
    background: #E3FCEF;
    color: #006644;
  }
</style>
